module.exports = __webpack_public_path__ + "static/media/Formato_Cargar_Calificaciones_Transportistas_v2.3a85885c.xlsx";